/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/
/*eslint no-redeclare: "off"*/
/*eslint array-callback-return: "off"*/
/* eslint-disable */
import React, { Component } from 'react'
import firebase from '../../config/database'
import componentsData from '../../config/builder/components.json'
import AppsData from '../../config/builder/apps.json'
import Tile from './../../ui/template/Tile'
import Config from './../../config/app'
import { Link } from 'react-router'
import SkyLight from 'react-skylight'
import NavBarDefault from './../../ui/template/NavBarDefault'
import { config } from '../../config/firebase_config';
import T from './../../translations/translate'
var md5 = require('md5');

const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;

class Apps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            apps: {},
            allapps: {},
            filter: "",
            user: {},
            containers: {}
        }
        this.printApps = this.printApps.bind(this);
        this.searchChange = this.searchChange.bind(this);
    }


    componentDidMount() {
        console.log("In apps.js");
        firebase.app.database().ref('containers').once('value', snap => {
            firebase.app.database().ref('applist').once('value', (snapshot) => {
                this.setState({
                    apps: snapshot.val(),
                    allapps: snapshot.val(),
                    containers: snap.val()
                })
            });
        })
        this.authListener();
    }

    authListener() {
        const setUser = (user) => {
            this.setState({ user: user })
        }

        //Now do the listner
        firebase.app.auth().onAuthStateChanged(function (user) {
            if (user) {
                setUser(user);
                // User is signed in.
                console.log("User has Logged  in Master");
                console.log(user.email);

            } else {
                // No user is signed in.
                console.log("User has logged out Master");
            }
        });
    }

    printApps() {
        var _this = this;
        return Object.keys(this.state.apps || {}).map(function (key) {
            console.log(key)
            return (_this.renderApp(_this.state.apps[key], key));
        })
    }

    searchChange(event) {
        this.setState({
            filter: event.target.value
        })

        if (event.target.value.length > 0) {

            var _this = this;
            var keys = Object.keys(this.state.allapps);
            var newListOfApps = {};
            for (let index = 0; index < keys.length; index++) {
                const key = keys[index];
                if (this.state.allapps[key].name.toLowerCase().indexOf(event.target.value.toLowerCase()) != -1) {
                    newListOfApps[key] = this.state.allapps[key];
                }
            }

            this.setState({
                apps: newListOfApps,
            });
        } else {
            this.setState({
                apps: this.state.allapps,
            });
        }
    }

    renderApp(appData, key) {
        return (
            <Tile
                key={key}
                image={appData.ai}
                link={"/#/sections/" + key}
                isIcon={false}
                subTitle={appData.id}
                title={appData.name}
                buttonTitle={T.td('Manage app')}
            />
        )
    }

    render() {

        var dialogStyle = {
            width: '40%',
            //height: '600px',
            //marginTop: '-300px',
            marginLeft: '-20%',
        };

        return (
            <div className="main-panel" style={{ width: '100%' }}>
                <NavBarDefault
                    currentLangData={this.props.route.currentLangData}
                    onChange={this.searchChange}
                    filter={this.state.filter}
                    user={this.state.user}
                    search={true}
                /><br /><br /><br /><br /><br />

                <div className="container-fluid">
                    <h6><b>{T.td('Single Event Apps')}</b></h6>

                    <div className="row">
                        <Tile
                            icon={"add_circle_outline"}
                            link={"/#/create/singleevent"}
                            isIcon={true}
                            // subTitle={T.ts('Create app from template')}
                            title={T.td('New app')}
                            buttonTitle={T.td('Create app')}
                        />

                        {this.printApps()}
                    </div>
                </div>
                {Object.keys(this.state.containers).map(c => {
                    var events = this.state.containers[c];
                    return (
                        <div className="container-fluid">
                            <h6><b>{'Container:- ' + c}</b></h6>

                            <div className="row">
                                <Tile
                                    icon={"add_circle_outline"}
                                    link={"/#/create/"+c}
                                    isIcon={true}
                                    // subTitle={T.ts('Create app from template')}
                                    title={'New app in ' + c}
                                    buttonTitle={T.td('Create app')}
                                />
                                {Object.keys(events).map(e => {
                                    var data = events[e];
                                    return (
                                        <Tile
                                            key={e}
                                            image={data.ai}
                                            link={"/#/sections/" + e}
                                            isIcon={false}
                                            subTitle={data.id}
                                            title={data.name}
                                            buttonTitle={T.td('Manage app')}
                                        />
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}

                {/* <div className="modal fade" id="exampleModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLabel">{T.td("User profile")}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">Ã—</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-dismiss="modal">{T.td("Close")}</button>
                                        <button type="button" className="btn btn-primary">{T.td("Save changes")}</button>
                                    </div>
                                </div>
                            </div>
                        </div> */}


                <footer className="footerfa" style={{ 'paddingTop': '24%' }}></footer>
            </div>
        )
    }
}
export default Apps;


// WEBPACK FOOTER //
// ./src/containers/Builder/Apps.js